import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=0aeacf10&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=0aeacf10&prod&scoped=true&lang=css"
import style1 from "./Orders.vue?vue&type=style&index=1&id=0aeacf10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeacf10",
  null
  
)

export default component.exports